const dev = process.env.NODE_ENV !== "production";
export const logWarn = (...args) => { if (dev) console.warn(...args); };
